/* assets/knot-add-on.js
 *
 * On a Brush Handle product page, intercepts "Add to Cart" and instead
 * adds BOTH the Handle's variant and the selected Knot's variant to the
 * cart together, then sends the customer to /cart to see both items.
 *
 * Matches Ride theme's actual buy-buttons.liquid markup:
 *   <product-form class="product-form">
 *     <form ... data-type="add-to-cart-form">
 *       <input type="hidden" name="id" class="product-variant-id" ...>
 *       <button type="submit" name="add" class="product-form__submit" ...>
 *
 * We attach our submit listener in the CAPTURE phase and call
 * stopImmediatePropagation() so Ride's own <product-form> submit handler
 * (which only knows how to add a single item) never runs for this form.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Accessibility fix: Ride's quantity input relies on an aria-labelledby
  // chain to a hidden span elsewhere on the page for its accessible name.
  // That chain is broken somewhere (empty translation string, or a CSS
  // technique on the hidden span that a11y tools don't recognize), so an
  // automated audit (axe) flags the quantity input as having no label.
  // Rather than edit Ride's core main-product.liquid to chase down the
  // root cause, we just guarantee a label directly here.
  document.querySelectorAll('.quantity__input').forEach(function (input) {
    if (!input.getAttribute('aria-label')) {
      input.setAttribute('aria-label', 'Quantity');
    }
  });

  var wrapper = document.querySelector('[data-knot-add-on]');
  if (!wrapper) return;

  var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  // Highlight the selected knot card
  wrapper.addEventListener('change', function (e) {
    if (e.target.name !== 'knot_variant_id') return;
    wrapper.querySelectorAll('.knot-option').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    e.target.closest('.knot-option').classList.add('is-selected');
  });

  productForm.addEventListener(
    'submit',
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // block Ride's own single-item add-to-cart handler

      var submitBtn = productForm.querySelector('.product-form__submit');
      var handleVariantInput = productForm.querySelector('.product-variant-id');
      var handleVariantId = handleVariantInput ? handleVariantInput.value : null;
      var knotInput = wrapper.querySelector('input[name="knot_variant_id"]:checked');
      var knotVariantId = knotInput ? knotInput.value : null;

      if (!handleVariantId) {
        console.error('knot-add-on: could not find the handle variant id (.product-variant-id input).');
        return;
      }

      var items = [{ id: parseInt(handleVariantId, 10), quantity: 1 }];
      if (knotVariantId) {
        items.push({ id: parseInt(knotVariantId, 10), quantity: 1 });
      }

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          // Send them to the cart to see both items land together.
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('knot-add-on: add to cart failed', err);
          if (submitBtn) {
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.classList.remove('loading');
          }
          alert('Sorry, something went wrong adding items to your cart. Please try again.');
        });
    },
    true // capture phase
  );
});
